import { urlParams } from '@lib/Utilities';

export function scaleToRange(value: number, from: number[], to: number[]): number {
    const scale = (to[1] - to[0]) / (from[1] - from[0]);
    const capped = Math.min(from[1], Math.max(from[0], value)) - from[0];
    return ~~(capped * scale + to[0]);
}

export function saveUTMsToSession() {
    const utms = urlParams(/^utm_/);
    if (utms) {
        const utmArray = Object.entries(utms);
        for (let i = 0; i < utmArray.length; i++) {
            const utm = utmArray[i];
            if (!sessionStorage.getItem(utm[0])) {
                sessionStorage.setItem(utm[0], JSON.stringify(utm[1]));
            }
        }
    }
    const gclikk = urlParams(/^gclid/);
    if (gclikk) {
        sessionStorage.setItem('googleClickID', JSON.stringify(gclikk.gclid));
    }
    const mclikk = urlParams(/^msclkid/);
    if (mclikk) {
        sessionStorage.setItem('microsoftClickID', JSON.stringify(mclikk.msclkid));
    }
}

export function getContactNumber(utmParam?: string | null) {
    if (utmParam === null) {
        return '866-308-1004';
    }

    if (utmParam === 'organic') {
        return '866-308-1004';
    }

    if (utmParam === 'cpc') {
        return '866-308-0901';
    }

    return '866-308-1004';
}
